<hr class="hr-line bg-color-dark-grey" />
<h1 class="card-title">
  <a
    tabindex="0"
    routerLink="/cursos/curso"
    *ngIf="tipo === 'vigentes' || tipo === 'curso' || cardTipo === 'mudouNome'"
    class="link"
    [queryParams]="{ id: itemId }"
  >
    {{ titulo }}
    <span *ngIf="cardTipo === 'mudouNome'"> > {{ cursoAtual }}</span>
  </a>
  <a
    tabindex="0"
    routerLink="/eixo-tecnologico"
    *ngIf="tipo === 'eixo'"
    [queryParams]="{ id: itemId }"
    class="link"
    >{{ titulo }}</a
  >
</h1>
<h1
  class="card-title"
  *ngIf="
    cardTipo === 'experimental' ||
    cardTipo === 'excluido' ||
    tipo === 'faq' ||
    tipo === 'legislacao'
  "
>
  {{ titulo }}
</h1>
<p class="card-text" *ngIf="cardTipo === 'excluido' || cardTipo === 'experimental'">
  Eixo tecnológico: {{ eixoNome | removeEixo }}
</p>
<p *ngIf="tipo === 'curso' || tipo === 'vigentes'" class="card-text">
  {{ texto | removeAsteristico | shorten }}
</p>
<p
  *ngIf="tipo === 'faq' || tipo === 'legislacao'"
  class="card-text grow"
  [innerHTML]="
    encurtarTexto
      ? (texto | removeAsteristico | textToLink | shorten)
      : (texto | removeAsteristico | textToLink)
  "
></p>
<button
  (click)="encurtarTexto = !encurtarTexto"
  role="button"
  *ngIf="
    (tipo === 'faq' && texto && displayBtn(texto | removeAsteristico | textToLink)) ||
    (tipo === 'legislacao' && texto && displayBtn(texto | removeAsteristico | textToLink))
  "
  class="btn btn-display cursor-pointer"
  [ngClass]="{ red: !encurtarTexto }"
>
  {{ encurtarTexto ? 'ver mais' : 'ver menos' }}
</button>
<span class="card-info" class="{{ bgColor }}" *ngIf="cursoMsg">{{ cursoMsg }}</span>
